import axios from 'axios';

const api = axios.create({
    baseURL: (window.location.origin.includes('localhost') || window.location.origin.includes('127.0.0.1'))
        ? 'http://127.0.0.1:8002/api/' 
        : '/api/',
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Token ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
